import React from 'react';
import { Helmet } from 'react-helmet';
import Breadcrumbs from '../components/Breadcrumbs';

const ImpressumPage = () => (
  <>
    <Helmet>
      <title>Impressum – Schlüsseldienst.services</title>
      <link rel="canonical" href="https://schluesseldienst.services/impressum/" />
    </Helmet>
    <div className="container mx-auto px-4 py-12">
      <Breadcrumbs items={[{ label: 'Impressum' }]} />
      <h1 className="text-4xl font-bold mb-8">Impressum</h1>
      <div className="max-w-3xl prose">
        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          Schössow Dienstleistungen UG (haftungsbeschränkt)<br/>
          Neben dem Brand 10<br/>
          44135 Dortmund
        </p>
        <p>
          <strong>Vertreten durch:</strong><br/>
          Andreas Schössow (Geschäftsführer)
        </p>
        <p>
          <strong>Kontakt:</strong><br/>
          Telefon: 0231 39085116<br/>
          E-Mail: info@schluesseldienst.services
        </p>
        <p>
          <strong>Registereintrag:</strong><br/>
          Eingetragen im Handelsregister<br/>
          Registergericht: Amtsgericht Dortmund<br/>
          Registernummer: HRB 29517
        </p>
        <p>
          <strong>Umsatzsteuer-ID:</strong><br/>
          Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz: DE310018782
        </p>
      </div>
    </div>
  </>
);

export default ImpressumPage;
